import Swal from "sweetalert2";
import "./ConfirmDialog.css";

const useConfirmDialog = () => {
  const showDialog = ({
    title = null,
    html,
    icon = "warning",
    iconHtml, // Para usar un ícono personalizado
    confirmButtonText = "Continuar",
    cancelButtonText = "Cancelar",
    confirmButtonColor = "#62C776",
    cancelButtonColor = "#223D51",
    confirmButtonClass = "BTN-dialog-confirmation", // Clase CSS personalizada
    cancelButtonClass = "BTN-dialog-cancel",
    mostrarCancelar = true,
    iconClass = null,
    onConfirm = () => {},
    onDeny = () => {},
    showDenyButton = false,
    denyButtonText = "No",
    denyButtonColor = "red",
    denyButtonClass = "BTN-dialog-deny",
    reverseButtons = false,
  }) => {
    Swal.fire({
      title,
      html,
      icon,
      iconHtml, // Ícono personalizado
      showCancelButton: mostrarCancelar ? true : false,
      confirmButtonColor,
      cancelButtonColor,
      confirmButtonText,
      cancelButtonText,
      customClass: {
        confirmButton: confirmButtonClass,
        cancelButton: cancelButtonClass,
        htmlContainer: "text-dialog",
        icon: iconClass,
        denyButton: denyButtonClass,
      },
      showDenyButton,
      denyButtonText,
      denyButtonColor,
      reverseButtons,
    }).then((result) => {
      if (result.isConfirmed) {
        onConfirm();
      }
      if (result.isDenied) {
        onDeny();
      }
    });
  };

  return showDialog;
};

export default useConfirmDialog;
